import React from 'react';
import cx from 'classnames';
import { I18n } from 'core';
import { MulticauOption } from 'types/state/ClientCupsState';

import styles from './MulticauChips.module.scss';

interface MulticauChipsProps {
  options: MulticauOption[];
  selected: MulticauOption;
  onChange: (option: MulticauOption) => void;
}

const MulticauChips = ({ options, selected, onChange }: MulticauChipsProps): JSX.Element => {
  const estadoLabel: Record<'activa' | 'baja', string> = {
    activa: I18n.t('Actiu'),
    baja: I18n.t('De baixa'),
  };

  return (
    <div className={styles.container}>
      <span className={styles.label}>{I18n.t('Comunitat')}</span>
      <div className={styles.chips}>
        {options.map((option) => {
          const estado = option.estadoCliente ? estadoLabel[option.estadoCliente] : undefined;
          const isDeBaja = option.estadoCliente === 'baja';
          return (
            <button
              key={String(option.id)}
              type="button"
              className={cx(styles.chip, { [styles.active]: option.id === selected.id })}
              onClick={() => onChange(option)}
              title={isDeBaja ? I18n.t('Client donat de baixa de la comunitat') : undefined}
            >
              {option.label}
              {estado && <span className={styles.bajaSuffix}>{` | ${estado}`}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MulticauChips;
